const discardUNiDChangesBtnClickHandlerUtil = ({
    dispatch,
    setPatientDetails,
    patientDetails,
    patientIdMandatory,
    filteredProduct,
    showReportPayment,
    myCaseRefId,
    getValidateItemsArr,
    validateProductDetails,
    validateAccountDetails,
    usageDetails,
    myCaseResourceType,
    reportPaymentGridData,
    getRPValidateItemsArr,
    isReplishBtnClicked,
    nextBtnClicked,
    setIsReplishBtnClicked,
    setNextBtnClicked,
    setReportPaymentScreenName,
    getModifiedButtonVisibilities,
    footerButtonStatuses,
    next,
    submit,
    setFooterButtonStatuses,
    setShowUNiDPopUp,
}) => {
    dispatch(setPatientDetails(patientDetails));
    if (
        (patientIdMandatory ? patientDetails?.hrefId?.length > 0 : true) &&
        filteredProduct.length > 0 &&
        !showReportPayment &&
        myCaseRefId
    ) {
        const validateItemsArr = getValidateItemsArr(filteredProduct);
        validateItemsArr.map(
            (item) =>
                item.accountOwned == undefined && delete item.accountOwned
        );
        const validateItemsObj = {
            myCaseRef: myCaseRefId,
            products: validateItemsArr,
        };
        dispatch(validateProductDetails(validateItemsObj, true));
        validateAccountDetails(usageDetails?.accountId);
        dispatch({
            type: 'SET_ITEMS_PRICING_DONE_FLAG',
            payload: false,
        });
    }
    if (
        myCaseResourceType === 'reportPayment' &&
        showReportPayment &&
        reportPaymentGridData.length > 0 &&
        myCaseRefId
    ) {
        const validateItemsArr = getRPValidateItemsArr(reportPaymentGridData);
        const validateItemsObj = {
            myCaseRef: myCaseRefId,
            products: validateItemsArr,
        };
        dispatch(validateProductDetails(validateItemsObj, true));
    }
    if (isReplishBtnClicked) {
        if (nextBtnClicked) {
            setIsReplishBtnClicked(false);
            dispatch(setReportPaymentScreenName('Replen'));
            var modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                next,
                submit
            );
            setFooterButtonStatuses(modifiedButtonStatuses);
        } else {
            setIsReplishBtnClicked(false);
            setNextBtnClicked(false);
        }
    }
    setShowUNiDPopUp(false);
};

export default discardUNiDChangesBtnClickHandlerUtil;